import { render, staticRenderFns } from "./TrainingGlobalStatistics.vue?vue&type=template&id=00c58c4e&"
import script from "./TrainingGlobalStatistics.vue?vue&type=script&lang=js&"
export * from "./TrainingGlobalStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports